import {
  BrowserRouter as Router,
  Switch,
  Route,
  Redirect,
} from "react-router-dom"
import Provider from "./components/Provider"
import Reject from "./components/Reject"

const App = () => {
  return (
    <Router>
      <Switch>
        <Route exact path="/">
          <Provider />
        </Route>
        <Route path="/reject">
          <Reject />
        </Route>
        <Redirect to="/" />
      </Switch>
    </Router>
  )
}

export default App
